import { render, staticRenderFns } from "./new_story_button.vue?vue&type=template&id=657489d8&scoped=true&lang=pug"
import script from "./new_story_button.vue?vue&type=script&lang=js"
export * from "./new_story_button.vue?vue&type=script&lang=js"
import style0 from "./new_story_button.vue?vue&type=style&index=0&id=657489d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657489d8",
  null
  
)

export default component.exports